<template>
  <HeadlessMenuItem
    class="block w-full px-3 py-2 text-center text-sm font-medium"
  >
    <template v-if="to">
      <RouterLink :to="to" v-bind="$attrs">
        <slot />
      </RouterLink>
    </template>
    <template v-else>
      <button type="button" v-bind="$attrs">
        <slot />
      </button>
    </template>
  </HeadlessMenuItem>
</template>

<script lang="ts">
export default {
  inheritAttrs: false,
}
</script>
<script setup lang="ts">
import type { RouteLocationRaw } from "vue-router"

const props = defineProps<{
  to?: RouteLocationRaw
}>()
</script>
